import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import OpenInNewTab3 from "@dcl/icons/esm/ui/open-in-new-tab-3-rebranding";

var GlobalFooterUnder = function GlobalFooterUnder(_ref) {
  var children = _ref.children,
      iconHref = _ref.iconHref,
      target = _ref.target,
      ariaLabel = _ref.ariaLabel;
  var getClassName = getClassNameFactory(GlobalFooterUnder.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, iconHref && /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "link"
    }),
    href: iconHref,
    target: target,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement("span", null, children, target === "_blank" && /*#__PURE__*/React.createElement(OpenInNewTab3, {
    size: 16
  }))));
};

GlobalFooterUnder.displayName = "GlobalFooterUnder";
GlobalFooterUnder.propTypes = {
  /**
   * Text content
   */
  children: PropTypes.node.isRequired,

  /**
   * URL for the icon link
   */
  iconHref: PropTypes.string,

  /**
   * Target for the icon link
   */
  target: PropTypes.string,

  /**
   * Aria Label for the icon link
   */
  ariaLabel: PropTypes.string
};
export default GlobalFooterUnder;